import { useState } from "react"
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import {blueberryTwilightPalette, mangoFusionPalette, cheerfulFiestaPalette, } from '@mui/x-charts/colorPalettes';
import { styled } from '@mui/material/styles';

const data = [
    {id: 0, value: 23.00, label: 'Arrhytmia'},
    {id: 1, value: 10.00, label: 'Unclassified'},
    {id: 2, value: 67.00, label: 'Sinus ok'}
] 

const palettes = {
    blueberryTwilight: blueberryTwilightPalette,
    mangoFusion: mangoFusionPalette,
    cheerfulFiesta: cheerfulFiestaPalette,
  };

const size = {
    width: 260,
    height: 160 ,
  };
  
const StyledText = styled('text')(({ theme }) => ({

fill: theme.palette.common.black,
textAnchor: 'middle',
dominantBaseline: 'central',
fontSize: '0.7rem',

}));


function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
        <StyledText x={left + width / 2} y={top + height / 2}>
        {children}
        </StyledText>
    );
    }

export default function RhythmChart() {

const [colorScheme, setColorScheme] = useState('cheerfulFiesta');

    return (
        <PieChart 
        
        margin={{ top: 0, bottom: 20, left: 0, right: 80 }}
        colors={palettes[colorScheme]}
        series={[{  data, 
                    outerRadius: 60, innerRadius: 45, cornerRadius: 6, paddingAngle: 4, 
                    highlightScope: { faded: 'global', highlighted: 'item' }, faded: { innerRadius: 30, additionalRadius: -30, color: 'white', fill: 'white' },  }]} 
        
        slotProps={{ 
                    legend: { direction: 'row', position: { vertical: 'bottom', horizontal: 'left' }, itemMarkWidth: 10, itemMarkHeight: 10, markGap: 5, itemGap: 5,
                    labelStyle: { fontSize: '0.6rem', fill: 'black', marginTop: 0 },
                    margin: {  },
                    },
        }}
        

      //  sx={{ [`& .${pieArcLabelClasses.root}`]: { fill: 'white', fontWeight: 'bold',  }, }} 
                            
        {...size}>
        
        <PieCenterLabel>Rhythm %</PieCenterLabel>
        
        </PieChart>
    );
}

/*
colors={['red', 'blue', 'green']} // Use palette

Sizing:

innerRadius: 30,
      outerRadius: 100,
      paddingAngle: 5,
      cornerRadius: 5,
      startAngle: -90,
      endAngle: 180,
      cx: 150,
      cy: 150,

Labels:

series={[
    {
      arcLabel: (item) => `${item.label} (${item.value})`,
      arcLabelMinAngle: 45,
      data,
    },
  ]}
  sx={{
    [`& .${pieArcLabelClasses.root}`]: {
      fill: 'white',
      fontWeight: 'bold',
    },
  }}
  {...size}

Legend:

 margin={{ top: 100, bottom: 100, left: 100, right:100 }}
  {/** ... * /}
  slotProps={{
    legend: {
      
    direction: 'column',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: 69,
      
      itemMarkWidth: 20,
      itemMarkHeight: 2,
      markGap: 5,
      itemGap: 10,

      labelStyle: {
        fontSize: 14,
        fill: 'blue',
      
    },
    margin: { top: 20, right: 100,  },
    },
  }}


*/